import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "driver-and-adapter-components"
    }}>{`Driver and adapter components`}</h1>
    <p>{`Venia's driver and adapter components give PWA Studio's React components access to components from external dependencies, such as the `}<em parentName="p">{`Link`}</em>{` component from the `}<em parentName="p">{`react-router-dom`}</em>{` package.`}</p>
    <h2 {...{
      "id": "driver-component"
    }}>{`Driver component`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-concept/src/drivers.js"
      }}>{`driver.js file`}</a>{` in Venia and the default project template returns a centralized module for Venia components that rely on external dependencies.
Instead of importing these dependencies directly, Venia components import them from the virtual dependency `}<inlineCode parentName="p">{`@magento/venia-drivers`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Link, resourceUrl } from "@magento/venia-drivers";
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`@magento/venia-drivers`}</inlineCode>{` dependency is not listed in the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file or available on the NPM registry.
It is a virtual dependency specified by the following entry in the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"browser": {
  "@magento/venia-drivers": "src/drivers"
}
`}</code></pre>
    <p>{`Webpack treats this package.json configuration as equivalent to a Webpack alias configuration, as required by `}<a parentName="p" {...{
        "href": "https://github.com/defunctzombie/package-browser-field-spec"
      }}>{`this draft specification`}</a>{`.
An app which imports anything from `}<inlineCode parentName="p">{`@magento/venia-ui`}</inlineCode>{` will substitute the virtual dependency for the real file at build time.`}</p>
    <h2 {...{
      "id": "adapter-component"
    }}>{`Adapter component`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/drivers/adapter.js"
      }}>{`adapter component`}</a>{` is a Venia driver that wraps around your application code to satisfy the implicit external dependencies of the Venia components it uses.
These dependencies include the `}<a parentName="p" {...{
        "href": "https://www.apollographql.com/docs/react/get-started/#connect-your-client-to-react"
      }}>{`ApolloProvider`}</a>{`, `}<a parentName="p" {...{
        "href": "https://react-redux.js.org/api/provider"
      }}>{`ReduxProvider`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://reactrouter.com/en/main/router-components/browser-router"
      }}>{`BrowserRouter`}</a>{`.`}</p>
    <p>{`Some of the Venia components in your storefront will not work if you do not wrap your application with the Venia adapter.
If you `}<a parentName="p" {...{
        "href": "/commerce/pwa-studio/tutorials/setup-storefront/"
      }}>{`set up your project`}</a>{` using the scaffolding tool, your project code already wraps the application with the adapter.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      